import React, { memo } from 'react';
import { BaseGlobalSearchLink } from 'site-modules/shared/components/inventory/global-search/global-search-links/base-global-search-link';
import { PersonalizedSearchLinkIcon } from 'site-modules/shared/components/inventory/global-search/global-search-links/personalized-search-link/personalized-search-link-icon';
import { PersonalizedSearchLinkTitle } from 'site-modules/shared/components/inventory/global-search/global-search-links/personalized-search-link/personalized-search-link-title';
import {
  GlobalSearchLinkDefaultProps,
  GlobalSearchLinkPropTypes,
} from 'site-modules/shared/constants/global-search/global-search-prop-types';

export const PersonalizedSearchLink = memo(props => {
  return (
    <BaseGlobalSearchLink
      {...props}
      linkThumbComponent={PersonalizedSearchLinkIcon}
      linkTitleComponent={PersonalizedSearchLinkTitle}
      rel="nofollow"
    />
  );
});

PersonalizedSearchLink.displayName = 'PersonalizedSearchLink';

PersonalizedSearchLink.propTypes = {
  ...GlobalSearchLinkPropTypes,
};

PersonalizedSearchLink.defaultProps = {
  ...GlobalSearchLinkDefaultProps,
};
